import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class AnalyticsAPI extends ComponentAPI {
    /**
     * Obtains the current component id.
     */
    getId() {
        return this.state.id;
    }
    /**
     * Updates the component id value.
     *
     * @param id - The updated id value.
     */
    setId(id) {
        this.setState({ id });
    }
    /**
     * Obtains the current component provider.
     */
    getProvider() {
        return this.state.provider;
    }
    /**
     * Updates the component provider value.
     *
     * @param id - The updated provider value.
     */
    setProvider(provider) {
        this.setState({ provider });
    }
}
export { AnalyticsAPI, };
//# sourceMappingURL=analytics-api.js.map